import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=f2d6f03c&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec_plaisir/b2b/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2d6f03c')) {
      api.createRecord('f2d6f03c', component.options)
    } else {
      api.reload('f2d6f03c', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=f2d6f03c&", function () {
      api.rerender('f2d6f03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Modal.vue"
export default component.exports